import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { PRICING } from "@/data/site";
import Reveal from "@/components/ui/reveal";

export default function Pricing() {
    return (
        <section id="cennik" className="border-t border-border bg-gr-surface2 py-20 dark:bg-gr-dsurface lg:py-28">
            <div className="container-gr">
                <div className="mx-auto max-w-2xl text-center">
                    <p className="font-mono text-xs uppercase tracking-[0.2em] text-gr-accent">Cennik</p>
                    <h2 className="mt-3 text-3xl tracking-tight text-foreground sm:text-4xl">Przejrzysty cennik, bez ukrytych opłat</h2>
                    <p className="mt-4 text-lg text-muted-foreground">Zacznij za darmo. Przejdź na PRO, gdy firma rośnie.</p>
                </div>

                <div className="mx-auto mt-14 grid max-w-5xl grid-cols-1 items-center gap-6 md:grid-cols-3">
                    {PRICING.map((p, i) => (
                        <Reveal key={p.id} delay={i * 0.08}>
                            <div
                                data-testid={`pricing-card-${p.id}`}
                                className={`relative rounded-3xl border p-8 ${
                                    p.featured
                                        ? "border-gr-primary bg-gr-primary text-white shadow-xl md:-translate-y-4 dark:border-gr-dprimary"
                                        : "border-border bg-card"
                                }`}
                            >
                                {p.featured && (
                                    <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-gr-accent px-4 py-1 font-mono text-[10px] font-bold uppercase tracking-wider text-gr-ink">
                                        Najpopularniejszy
                                    </span>
                                )}
                                <h3 className={`font-heading text-lg font-extrabold ${p.featured ? "text-white" : "text-foreground"}`}>{p.name}</h3>
                                <p className={`mt-1 text-sm ${p.featured ? "text-white/70" : "text-muted-foreground"}`}>{p.tagline}</p>
                                <div className="mt-6 flex items-baseline gap-1">
                                    <span className={`font-heading text-4xl font-extrabold ${p.featured ? "text-white" : "text-foreground"}`}>{p.price}</span>
                                    <span className={`text-sm ${p.featured ? "text-white/70" : "text-muted-foreground"}`}>{p.period}</span>
                                </div>
                                <ul className="mt-6 space-y-3">
                                    {p.features.map((f) => (
                                        <li key={f} className="flex items-start gap-2.5">
                                            <Check className={`mt-0.5 h-4 w-4 shrink-0 ${p.featured ? "text-gr-accent" : "text-gr-primary dark:text-gr-dprimary"}`} />
                                            <span className={`text-sm ${p.featured ? "text-white/90" : "text-foreground"}`}>{f}</span>
                                        </li>
                                    ))}
                                </ul>
                                <Link
                                    to="/download"
                                    data-testid={`pricing-cta-${p.id}`}
                                    className={`mt-8 block rounded-full px-6 py-3 text-center text-sm font-semibold transition-transform active:scale-95 ${
                                        p.featured
                                            ? "bg-white text-gr-primary hover:brightness-95"
                                            : "bg-primary text-primary-foreground hover:brightness-110"
                                    }`}
                                >
                                    {p.cta}
                                </Link>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
